var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetMobileStarfield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 393 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_1864)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_880_1864)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.7783,
    cy: 243.939,
    r: 0.780975,
    transform: "rotate(90.19 17.7783 243.939)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.974,
    cy: 453.824,
    r: 0.536569,
    transform: "rotate(90.19 340.974 453.824)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.422,
    cy: 105.03,
    r: 0.580716,
    transform: "rotate(90.19 229.422 105.03)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.139,
    cy: 107.605,
    r: 0.482412,
    transform: "rotate(90.19 171.139 107.605)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.755,
    cy: 500.645,
    r: 0.408837,
    transform: "rotate(90.19 207.755 500.645)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.331,
    cy: 179.991,
    r: 0.774477,
    transform: "rotate(90.19 362.331 179.991)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.814,
    cy: 187.154,
    r: 0.759255,
    transform: "rotate(90.19 311.814 187.154)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.68,
    cy: 326.169,
    r: 0.685273,
    transform: "rotate(90.19 325.68 326.169)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.203,
    cy: 8.07282,
    r: 0.564436,
    transform: "rotate(90.19 147.203 8.07282)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.699,
    cy: 674.862,
    r: 0.616433,
    transform: "rotate(90.19 334.699 674.862)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.956,
    cy: 152.948,
    r: 0.621269,
    transform: "rotate(90.19 233.956 152.948)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.513,
    cy: 146.92,
    r: 0.58728,
    transform: "rotate(90.19 376.513 146.92)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.4738,
    cy: 421.517,
    r: 0.787798,
    transform: "rotate(90.19 87.4738 421.517)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.994,
    cy: 450.224,
    r: 0.588964,
    transform: "rotate(90.19 211.994 450.224)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.42,
    cy: 403.716,
    r: 0.452299,
    transform: "rotate(90.19 166.42 403.716)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.2106,
    cy: 532.936,
    r: 0.788769,
    transform: "rotate(90.19 13.2106 532.936)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.181,
    cy: 146.879,
    r: 0.631754,
    transform: "rotate(90.19 194.181 146.879)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1912,
    cy: 459.724,
    r: 0.527875,
    transform: "rotate(90.19 61.1912 459.724)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.096,
    cy: 396.683,
    r: 0.612323,
    transform: "rotate(90.19 241.096 396.683)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.2637,
    cy: 486.135,
    r: 0.449316,
    transform: "rotate(90.19 72.2637 486.135)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.439,
    cy: 250.676,
    r: 0.690286,
    transform: "rotate(90.19 316.439 250.676)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.85,
    cy: 430.285,
    r: 0.448553,
    transform: "rotate(90.19 212.85 430.285)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.814,
    cy: 411.535,
    r: 0.538863,
    transform: "rotate(90.19 353.814 411.535)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.747,
    cy: 328.957,
    r: 0.432544,
    transform: "rotate(90.19 342.747 328.957)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.0653,
    cy: 503.938,
    r: 0.643787,
    transform: "rotate(90.19 26.0653 503.938)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.2185,
    cy: 452.366,
    r: 0.582342,
    transform: "rotate(90.19 96.2185 452.366)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.771,
    cy: 249.284,
    r: 0.598075,
    transform: "rotate(90.19 336.771 249.284)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.602,
    cy: 389.985,
    r: 0.734767,
    transform: "rotate(90.19 209.602 389.985)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.945,
    cy: 388.067,
    r: 0.767344,
    transform: "rotate(90.19 387.945 388.067)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.824,
    cy: 165.571,
    r: 0.625111,
    transform: "rotate(90.19 322.824 165.571)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.449,
    cy: 393.73,
    r: 0.674571,
    transform: "rotate(90.19 271.449 393.73)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.731,
    cy: 431.554,
    r: 0.587176,
    transform: "rotate(90.19 353.731 431.554)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.3947,
    cy: 615.812,
    r: 0.745383,
    transform: "rotate(90.19 86.3947 615.812)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.317,
    cy: 519.217,
    r: 0.703291,
    transform: "rotate(90.19 362.317 519.217)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.928,
    cy: 694.517,
    r: 0.53832,
    transform: "rotate(90.19 315.928 694.517)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.825,
    cy: 111.33,
    r: 0.412089,
    transform: "rotate(90.19 344.825 111.33)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.4495,
    cy: 650.373,
    r: 0.436386,
    transform: "rotate(90.19 47.4495 650.373)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.784,
    cy: 636.959,
    r: 0.654012,
    transform: "rotate(90.19 253.784 636.959)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.456,
    cy: 355.308,
    r: 0.715885,
    transform: "rotate(90.19 133.456 355.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.7939,
    cy: 680.734,
    r: 0.611647,
    transform: "rotate(90.19 76.7939 680.734)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.2156,
    cy: 650.166,
    r: 0.524091,
    transform: "rotate(90.19 37.2156 650.166)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.375,
    cy: 613.094,
    r: 0.769929,
    transform: "rotate(90.19 209.375 613.094)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.517,
    cy: 622.677,
    r: 0.652538,
    transform: "rotate(90.19 335.517 622.677)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.491,
    cy: 435.711,
    r: 0.440851,
    transform: "rotate(90.19 103.491 435.711)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.839,
    cy: 263.994,
    r: 0.77189,
    transform: "rotate(90.19 114.839 263.994)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.7511,
    cy: 521.493,
    r: 0.456456,
    transform: "rotate(90.19 45.7511 521.493)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.415,
    cy: 294.416,
    r: 0.539691,
    transform: "rotate(90.19 345.415 294.416)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.794,
    cy: 195.595,
    r: 0.531728,
    transform: "rotate(90.19 139.794 195.595)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5889,
    cy: 460.071,
    r: 0.398435,
    transform: "rotate(90.19 41.5889 460.071)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.362,
    cy: 144.518,
    r: 0.615365,
    transform: "rotate(90.19 117.362 144.518)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.3341,
    cy: 593.803,
    r: 0.658919,
    transform: "rotate(90.19 54.3341 593.803)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.492,
    cy: 205.072,
    r: 0.48357,
    transform: "rotate(90.19 286.492 205.072)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.645,
    cy: 179.175,
    r: 0.701545,
    transform: "rotate(90.19 213.645 179.175)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2712,
    cy: 671.562,
    r: 0.528097,
    transform: "rotate(90.19 32.2712 671.562)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.463,
    cy: 12.8626,
    r: 0.428273,
    transform: "rotate(90.19 312.463 12.8626)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.299,
    cy: 544.798,
    r: 0.649547,
    transform: "rotate(90.19 273.299 544.798)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.686,
    cy: 499.765,
    r: 0.69618,
    transform: "rotate(90.19 173.686 499.765)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.872,
    cy: 1.08795,
    r: 0.499522,
    transform: "rotate(90.19 300.872 1.08795)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.363,
    cy: 27.136,
    r: 0.431404,
    transform: "rotate(90.19 151.363 27.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.558,
    cy: 522.025,
    r: 0.45753,
    transform: "rotate(90.19 370.558 522.025)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.172,
    cy: 273.474,
    r: 0.469689,
    transform: "rotate(90.19 337.172 273.474)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.373,
    cy: 64.7383,
    r: 0.708184,
    transform: "rotate(90.19 105.373 64.7383)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.908,
    cy: 298.136,
    r: 0.511894,
    transform: "rotate(90.19 117.908 298.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.039,
    cy: 411.535,
    r: 0.553363,
    transform: "rotate(90.19 185.039 411.535)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.344,
    cy: 112.638,
    r: 0.471016,
    transform: "rotate(90.19 50.344 112.638)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.1096,
    cy: 572.274,
    r: 0.520625,
    transform: "rotate(90.19 50.1096 572.274)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.2262,
    cy: 540.479,
    r: 0.596503,
    transform: "rotate(90.19 84.2262 540.479)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.8656,
    cy: 110.753,
    r: 0.484695,
    transform: "rotate(90.19 57.8656 110.753)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.63,
    cy: 337.525,
    r: 0.661671,
    transform: "rotate(90.19 213.63 337.525)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.812,
    cy: 176.957,
    r: 0.757512,
    transform: "rotate(90.19 312.812 176.957)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.893,
    cy: 399.716,
    r: 0.637115,
    transform: "rotate(90.19 269.893 399.716)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.759,
    cy: 278.67,
    r: 0.779836,
    transform: "rotate(90.19 132.759 278.67)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.906,
    cy: 487.631,
    r: 0.764152,
    transform: "rotate(90.19 387.906 487.631)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.42,
    cy: 15.0684,
    r: 0.61761,
    transform: "rotate(90.19 228.42 15.0684)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.17,
    cy: 682.928,
    r: 0.787171,
    transform: "rotate(90.19 236.17 682.928)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.9219,
    cy: 398.732,
    r: 0.447121,
    transform: "rotate(90.19 45.9219 398.732)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.956,
    cy: 358.309,
    r: 0.667205,
    transform: "rotate(90.19 116.956 358.309)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.2548,
    cy: 166.809,
    r: 0.432739,
    transform: "rotate(90.19 10.2548 166.809)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.12,
    cy: 627.391,
    r: 0.573127,
    transform: "rotate(90.19 340.12 627.391)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.63835,
    cy: 169.335,
    r: 0.527746,
    transform: "rotate(90.19 9.63835 169.335)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.753,
    cy: 105.929,
    r: 0.699138,
    transform: "rotate(90.19 67.753 105.929)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.622,
    cy: 466.383,
    r: 0.68927,
    transform: "rotate(90.19 368.622 466.383)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.451,
    cy: 677.977,
    r: 0.401975,
    transform: "rotate(90.19 177.451 677.977)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.852,
    cy: 164.704,
    r: 0.619957,
    transform: "rotate(90.19 119.852 164.704)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.261,
    cy: 83.8429,
    r: 0.627944,
    transform: "rotate(90.19 128.261 83.8429)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.7723,
    cy: 25.4314,
    r: 0.760137,
    transform: "rotate(90.19 45.7723 25.4314)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.09,
    cy: 52.1385,
    r: 0.749617,
    transform: "rotate(90.19 250.09 52.1385)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.55,
    cy: 588.584,
    r: 0.443517,
    transform: "rotate(90.19 377.55 588.584)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.867,
    cy: 126.349,
    r: 0.541795,
    transform: "rotate(90.19 385.867 126.349)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.3661,
    cy: 632.606,
    r: 0.596805,
    transform: "rotate(90.19 34.3661 632.606)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.903,
    cy: 561.695,
    r: 0.725282,
    transform: "rotate(90.19 129.903 561.695)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.869,
    cy: 652.848,
    r: 0.504018,
    transform: "rotate(90.19 270.869 652.848)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.2312,
    cy: 635.486,
    r: 0.403716,
    transform: "rotate(90.19 90.2312 635.486)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.403,
    cy: 453.834,
    r: 0.518849,
    transform: "rotate(90.19 117.403 453.834)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.31,
    cy: 288.394,
    r: 0.497497,
    transform: "rotate(90.19 148.31 288.394)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.412,
    cy: 555.889,
    r: 0.694499,
    transform: "rotate(90.19 208.412 555.889)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.031,
    cy: 299.872,
    r: 0.751719,
    transform: "rotate(90.19 299.031 299.872)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.324,
    cy: 190.136,
    r: 0.569331,
    transform: "rotate(90.19 180.324 190.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.481,
    cy: 502.3,
    r: 0.469353,
    transform: "rotate(90.19 121.481 502.3)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.076,
    cy: 515.787,
    r: 0.442206,
    transform: "rotate(90.19 120.076 515.787)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.234,
    cy: 298.1,
    r: 0.472571,
    transform: "rotate(90.19 36.234 298.1)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.054,
    cy: 103.749,
    r: 0.630978,
    transform: "rotate(90.19 383.054 103.749)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.711,
    cy: 265.443,
    r: 0.545854,
    transform: "rotate(90.19 245.711 265.443)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.035,
    cy: 1.48345,
    r: 0.55708,
    transform: "rotate(90.19 218.035 1.48345)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.738,
    cy: 342.831,
    r: 0.493233,
    transform: "rotate(90.19 175.738 342.831)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.1204,
    cy: 408.503,
    r: 0.642936,
    transform: "rotate(90.19 16.1204 408.503)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.098,
    cy: 83.6503,
    r: 0.694606,
    transform: "rotate(90.19 337.098 83.6503)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.865,
    cy: 378.262,
    r: 0.526652,
    transform: "rotate(90.19 171.865 378.262)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.321,
    cy: 482.891,
    r: 0.703465,
    transform: "rotate(90.19 245.321 482.891)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.273,
    cy: 309.156,
    r: 0.749249,
    transform: "rotate(90.19 363.273 309.156)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.9697,
    cy: 377.463,
    r: 0.786851,
    transform: "rotate(90.19 36.9697 377.463)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.606,
    cy: 77.5219,
    r: 0.484701,
    transform: "rotate(90.19 195.606 77.5219)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.647,
    cy: 568.53,
    r: 0.777506,
    transform: "rotate(90.19 389.647 568.53)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.127,
    cy: 251.49,
    r: 0.529062,
    transform: "rotate(90.19 302.127 251.49)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.336,
    cy: 371.431,
    r: 0.779831,
    transform: "rotate(90.19 150.336 371.431)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.491,
    cy: 450.328,
    r: 0.614905,
    transform: "rotate(90.19 279.491 450.328)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.382,
    cy: 239.251,
    r: 0.597742,
    transform: "rotate(90.19 323.382 239.251)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.404,
    cy: 691.575,
    r: 0.608055,
    transform: "rotate(90.19 236.404 691.575)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.122,
    cy: 55.1005,
    r: 0.538532,
    transform: "rotate(90.19 209.122 55.1005)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.89,
    cy: 316.199,
    r: 0.401025,
    transform: "rotate(90.19 365.89 316.199)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.6161,
    cy: 322.081,
    r: 0.446096,
    transform: "rotate(90.19 25.6161 322.081)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.212,
    cy: 448.185,
    r: 0.754392,
    transform: "rotate(90.19 327.212 448.185)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.399,
    cy: 36.1625,
    r: 0.644872,
    transform: "rotate(90.19 196.399 36.1625)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6309,
    cy: 480.265,
    r: 0.492852,
    transform: "rotate(90.19 55.6309 480.265)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.456,
    cy: 97.4211,
    r: 0.464642,
    transform: "rotate(90.19 341.456 97.4211)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.19,
    cy: 657.816,
    r: 0.748317,
    transform: "rotate(90.19 158.19 657.816)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.72,
    cy: 636.051,
    r: 0.474848,
    transform: "rotate(90.19 190.72 636.051)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.022,
    cy: 421.185,
    r: 0.429397,
    transform: "rotate(90.19 203.022 421.185)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4422,
    cy: 379.184,
    r: 0.736167,
    transform: "rotate(90.19 83.4422 379.184)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.669,
    cy: 362.359,
    r: 0.705864,
    transform: "rotate(90.19 287.669 362.359)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.408,
    cy: 7.67233,
    r: 0.657914,
    transform: "rotate(90.19 156.408 7.67233)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.709,
    cy: 672.84,
    r: 0.479063,
    transform: "rotate(90.19 317.709 672.84)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.832,
    cy: 95.6494,
    r: 0.730692,
    transform: "rotate(90.19 137.832 95.6494)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.255,
    cy: 368.552,
    r: 0.454137,
    transform: "rotate(90.19 109.255 368.552)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.859,
    cy: 554.501,
    r: 0.686597,
    transform: "rotate(90.19 282.859 554.501)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.023,
    cy: 445.625,
    r: 0.466084,
    transform: "rotate(90.19 356.023 445.625)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.176,
    cy: 144.722,
    r: 0.602709,
    transform: "rotate(90.19 307.176 144.722)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.825,
    cy: 167.813,
    r: 0.630753,
    transform: "rotate(90.19 183.825 167.813)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.7087,
    cy: 309.367,
    r: 0.570881,
    transform: "rotate(90.19 93.7087 309.367)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.472,
    cy: 517.819,
    r: 0.443384,
    transform: "rotate(90.19 254.472 517.819)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.283,
    cy: 119.806,
    r: 0.559341,
    transform: "rotate(90.19 165.283 119.806)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.731,
    cy: 496.649,
    r: 0.743894,
    transform: "rotate(90.19 180.731 496.649)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.354,
    cy: 558.513,
    r: 0.474658,
    transform: "rotate(90.19 207.354 558.513)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.436,
    cy: 64.6981,
    r: 0.763629,
    transform: "rotate(90.19 248.436 64.6981)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.8073,
    cy: 607.889,
    r: 0.689466,
    transform: "rotate(90.19 90.8073 607.889)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.502,
    cy: 670.095,
    r: 0.774375,
    transform: "rotate(90.19 53.502 670.095)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5636,
    cy: 336.71,
    r: 0.653583,
    transform: "rotate(90.19 30.5636 336.71)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.358,
    cy: 654.351,
    r: 0.599332,
    transform: "rotate(90.19 175.358 654.351)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.9686,
    cy: 121.209,
    r: 0.43597,
    transform: "rotate(90.19 10.9686 121.209)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.256,
    cy: 663.201,
    r: 0.714091,
    transform: "rotate(90.19 379.256 663.201)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.835,
    cy: 49.2688,
    r: 0.464239,
    transform: "rotate(90.19 280.835 49.2688)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.4464,
    cy: 296.778,
    r: 0.473903,
    transform: "rotate(90.19 4.4464 296.778)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.8002,
    cy: 550.467,
    r: 0.440381,
    transform: "rotate(90.19 47.8002 550.467)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.127,
    cy: 702.599,
    r: 0.498788,
    transform: "rotate(90.19 245.127 702.599)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.984,
    cy: 421.222,
    r: 0.714356,
    transform: "rotate(90.19 324.984 421.222)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.773,
    cy: 702.622,
    r: 0.602039,
    transform: "rotate(90.19 190.773 702.622)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.2313,
    cy: 530.878,
    r: 0.456227,
    transform: "rotate(90.19 83.2313 530.878)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.557,
    cy: 363.449,
    r: 0.573962,
    transform: "rotate(90.19 380.557 363.449)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.593,
    cy: 476.712,
    r: 0.749477,
    transform: "rotate(90.19 382.593 476.712)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.111,
    cy: 351.671,
    r: 0.706337,
    transform: "rotate(90.19 144.111 351.671)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.175,
    cy: 314.116,
    r: 0.68063,
    transform: "rotate(90.19 352.175 314.116)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.224,
    cy: 351.323,
    r: 0.730926,
    transform: "rotate(90.19 233.224 351.323)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.657,
    cy: 314.41,
    r: 0.416423,
    transform: "rotate(90.19 303.657 314.41)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.123,
    cy: 26.981,
    r: 0.446303,
    transform: "rotate(90.19 266.123 26.981)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.016,
    cy: 309.199,
    r: 0.561215,
    transform: "rotate(90.19 201.016 309.199)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.451,
    cy: 27.9208,
    r: 0.71962,
    transform: "rotate(90.19 382.451 27.9208)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.461,
    cy: 317.482,
    r: 0.668407,
    transform: "rotate(90.19 347.461 317.482)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.681,
    cy: 669.096,
    r: 0.777447,
    transform: "rotate(90.19 250.681 669.096)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.6278,
    cy: 354.407,
    r: 0.406046,
    transform: "rotate(90.19 75.6278 354.407)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.925,
    cy: 63.1989,
    r: 0.469944,
    transform: "rotate(90.19 278.925 63.1989)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.874,
    cy: 93.1157,
    r: 0.794633,
    transform: "rotate(90.19 386.874 93.1157)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.082,
    cy: 413.545,
    r: 0.455366,
    transform: "rotate(90.19 145.082 413.545)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.484,
    cy: 694.009,
    r: 0.613258,
    transform: "rotate(90.19 163.484 694.009)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.469,
    cy: 376.63,
    r: 0.448691,
    transform: "rotate(90.19 181.469 376.63)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.023,
    cy: 311.952,
    r: 0.592332,
    transform: "rotate(90.19 200.023 311.952)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5524,
    cy: 30.6641,
    r: 0.490168,
    transform: "rotate(90.19 52.5524 30.6641)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.945,
    cy: 589.013,
    r: 0.787687,
    transform: "rotate(90.19 192.945 589.013)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.687,
    cy: 3.43091,
    r: 0.619004,
    transform: "rotate(90.19 227.687 3.43091)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.475,
    cy: 452.829,
    r: 0.497276,
    transform: "rotate(90.19 135.475 452.829)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.022,
    cy: 16.0889,
    r: 0.591373,
    transform: "rotate(90.19 387.022 16.0889)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.381,
    cy: 240.402,
    r: 0.529101,
    transform: "rotate(90.19 393.381 240.402)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.2336,
    cy: 218.98,
    r: 0.421497,
    transform: "rotate(90.19 97.2336 218.98)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.87,
    cy: 669.82,
    r: 0.717002,
    transform: "rotate(90.19 355.87 669.82)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.3648,
    cy: 588.677,
    r: 0.676012,
    transform: "rotate(90.19 58.3648 588.677)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.964,
    cy: 141.44,
    r: 0.590592,
    transform: "rotate(90.19 209.964 141.44)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6017,
    cy: 192.978,
    r: 0.731376,
    transform: "rotate(90.19 15.6017 192.978)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.9919,
    cy: 614.62,
    r: 0.682871,
    transform: "rotate(90.19 45.9919 614.62)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.092,
    cy: 696.246,
    r: 0.647233,
    transform: "rotate(90.19 329.092 696.246)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.838,
    cy: 306.765,
    r: 0.745435,
    transform: "rotate(90.19 342.838 306.765)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.054,
    cy: 510.183,
    r: 0.500558,
    transform: "rotate(90.19 152.054 510.183)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4773,
    cy: 434.938,
    r: 0.511497,
    transform: "rotate(90.19 60.4773 434.938)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.505,
    cy: 73.5259,
    r: 0.533532,
    transform: "rotate(90.19 325.505 73.5259)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.91,
    cy: 55.0444,
    r: 0.701553,
    transform: "rotate(90.19 135.91 55.0444)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7311,
    cy: 280.303,
    r: 0.731316,
    transform: "rotate(90.19 15.7311 280.303)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.144,
    cy: 74.2178,
    r: 0.736585,
    transform: "rotate(90.19 211.144 74.2178)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.008,
    cy: 353.303,
    r: 0.59389,
    transform: "rotate(90.19 241.008 353.303)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.155,
    cy: 88.5383,
    r: 0.672077,
    transform: "rotate(90.19 280.155 88.5383)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.621,
    cy: 544.986,
    r: 0.423225,
    transform: "rotate(90.19 249.621 544.986)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.076,
    cy: 328.003,
    r: 0.435177,
    transform: "rotate(90.19 374.076 328.003)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.4406,
    cy: 194.725,
    r: 0.485246,
    transform: "rotate(90.19 84.4406 194.725)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.525,
    cy: 572.752,
    r: 0.641697,
    transform: "rotate(90.19 316.525 572.752)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.648,
    cy: 127.897,
    r: 0.57744,
    transform: "rotate(90.19 285.648 127.897)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.224,
    cy: 368.155,
    r: 0.673724,
    transform: "rotate(90.19 129.224 368.155)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.2,
    cy: 146.688,
    r: 0.649812,
    transform: "rotate(90.19 240.2 146.688)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.4815,
    cy: 661.901,
    r: 0.702681,
    transform: "rotate(90.19 91.4815 661.901)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.936,
    cy: 602.142,
    r: 0.594376,
    transform: "rotate(90.19 157.936 602.142)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.853,
    cy: 597.536,
    r: 0.487809,
    transform: "rotate(90.19 324.853 597.536)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.115,
    cy: 176.91,
    r: 0.788661,
    transform: "rotate(90.19 246.115 176.91)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.947,
    cy: 631.826,
    r: 0.491693,
    transform: "rotate(90.19 378.947 631.826)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.4621,
    cy: 607.394,
    r: 0.566565,
    transform: "rotate(90.19 11.4621 607.394)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.961,
    cy: 7.46185,
    r: 0.412441,
    transform: "rotate(90.19 129.961 7.46185)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.05,
    cy: 266.715,
    r: 0.656855,
    transform: "rotate(90.19 216.05 266.715)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.8121,
    cy: 304.564,
    r: 0.60262,
    transform: "rotate(90.19 47.8121 304.564)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.517,
    cy: 283.157,
    r: 0.730026,
    transform: "rotate(90.19 332.517 283.157)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.017,
    cy: 341.667,
    r: 0.666636,
    transform: "rotate(90.19 283.017 341.667)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.917,
    cy: 61.7473,
    r: 0.658453,
    transform: "rotate(90.19 130.917 61.7473)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.651,
    cy: 195.92,
    r: 0.430495,
    transform: "rotate(90.19 205.651 195.92)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.265,
    cy: 649.804,
    r: 0.702962,
    transform: "rotate(90.19 229.265 649.804)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.851,
    cy: 262.065,
    r: 0.46178,
    transform: "rotate(90.19 171.851 262.065)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.95,
    cy: 571.306,
    r: 0.584335,
    transform: "rotate(90.19 279.95 571.306)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4971,
    cy: 575.94,
    r: 0.451326,
    transform: "rotate(90.19 55.4971 575.94)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.242,
    cy: 362.361,
    r: 0.505657,
    transform: "rotate(90.19 321.242 362.361)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.26,
    cy: 406.016,
    r: 0.599615,
    transform: "rotate(90.19 261.26 406.016)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5407,
    cy: 311.942,
    r: 0.589429,
    transform: "rotate(90.19 89.5407 311.942)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.234,
    cy: 22.7078,
    r: 0.738552,
    transform: "rotate(90.19 201.234 22.7078)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.323,
    cy: 286.527,
    r: 0.582587,
    transform: "rotate(90.19 104.323 286.527)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.859,
    cy: 60.4649,
    r: 0.518359,
    transform: "rotate(90.19 39.859 60.4649)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.663,
    cy: 393.382,
    r: 0.763246,
    transform: "rotate(90.19 239.663 393.382)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.3589,
    cy: 77.6259,
    r: 0.423254,
    transform: "rotate(90.19 83.3589 77.6259)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.876,
    cy: 681.684,
    r: 0.672977,
    transform: "rotate(90.19 119.876 681.684)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1074,
    cy: 610.385,
    r: 0.453312,
    transform: "rotate(90.19 96.1074 610.385)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.696,
    cy: 260.409,
    r: 0.623687,
    transform: "rotate(90.19 256.696 260.409)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.315,
    cy: 71.654,
    r: 0.607629,
    transform: "rotate(90.19 381.315 71.654)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.268,
    cy: 658.14,
    r: 0.46643,
    transform: "rotate(90.19 362.268 658.14)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.478,
    cy: 650.306,
    r: 0.623565,
    transform: "rotate(90.19 286.478 650.306)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.255,
    cy: 85.9591,
    r: 0.416294,
    transform: "rotate(90.19 195.255 85.9591)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.035,
    cy: 572.593,
    r: 0.781731,
    transform: "rotate(90.19 330.035 572.593)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.553,
    cy: 203.808,
    r: 0.476222,
    transform: "rotate(90.19 156.553 203.808)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.341,
    cy: 280.051,
    r: 0.531893,
    transform: "rotate(90.19 113.341 280.051)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.8133,
    cy: 185.536,
    r: 0.422032,
    transform: "rotate(90.19 65.8133 185.536)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.955,
    cy: 461.265,
    r: 0.623639,
    transform: "rotate(90.19 359.955 461.265)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.691,
    cy: 101.504,
    r: 0.402498,
    transform: "rotate(90.19 324.691 101.504)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.917,
    cy: 433.647,
    r: 0.620857,
    transform: "rotate(90.19 62.917 433.647)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.768,
    cy: 207.826,
    r: 0.399824,
    transform: "rotate(90.19 220.768 207.826)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8231,
    cy: 205.796,
    r: 0.585003,
    transform: "rotate(90.19 16.8231 205.796)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.005,
    cy: 339.246,
    r: 0.579233,
    transform: "rotate(90.19 256.005 339.246)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.993,
    cy: 575.625,
    r: 0.716168,
    transform: "rotate(90.19 270.993 575.625)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.6558,
    cy: 196.566,
    r: 0.703638,
    transform: "rotate(90.19 88.6558 196.566)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.01,
    cy: 447.308,
    r: 0.652595,
    transform: "rotate(90.19 116.01 447.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.652,
    cy: 63.5865,
    r: 0.606334,
    transform: "rotate(90.19 214.652 63.5865)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.169,
    cy: 311.248,
    r: 0.507904,
    transform: "rotate(90.19 263.169 311.248)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.2277,
    cy: 75.4422,
    r: 0.477471,
    transform: "rotate(90.19 43.2277 75.4422)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.319,
    cy: 687.559,
    r: 0.477936,
    transform: "rotate(90.19 157.319 687.559)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5434,
    cy: 361.406,
    r: 0.594122,
    transform: "rotate(90.19 43.5434 361.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.362,
    cy: 688.242,
    r: 0.770597,
    transform: "rotate(90.19 223.362 688.242)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.7046,
    cy: 59.9732,
    r: 0.402063,
    transform: "rotate(90.19 80.7046 59.9732)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.915,
    cy: 105.35,
    r: 0.499671,
    transform: "rotate(90.19 338.915 105.35)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.764,
    cy: 10.2199,
    r: 0.511855,
    transform: "rotate(90.19 298.764 10.2199)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.2962,
    cy: 111.449,
    r: 0.519382,
    transform: "rotate(90.19 36.2962 111.449)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.182,
    cy: 679.711,
    r: 0.472267,
    transform: "rotate(90.19 119.182 679.711)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.601,
    cy: 225.622,
    r: 0.428267,
    transform: "rotate(90.19 263.601 225.622)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.969,
    cy: 540.827,
    r: 0.671373,
    transform: "rotate(90.19 139.969 540.827)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.722,
    cy: 182.98,
    r: 0.55958,
    transform: "rotate(90.19 313.722 182.98)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.242,
    cy: 185.746,
    r: 0.717861,
    transform: "rotate(90.19 374.242 185.746)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.949,
    cy: 144.055,
    r: 0.580655,
    transform: "rotate(90.19 219.949 144.055)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.334,
    cy: 447.327,
    r: 0.683474,
    transform: "rotate(90.19 243.334 447.327)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.122,
    cy: 72.136,
    r: 0.527865,
    transform: "rotate(90.19 198.122 72.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.96161,
    cy: 280.166,
    r: 0.72848,
    transform: "rotate(90.19 2.96161 280.166)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.2095,
    cy: 93.5017,
    r: 0.577359,
    transform: "rotate(90.19 76.2095 93.5017)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.44,
    cy: 209.728,
    r: 0.535956,
    transform: "rotate(90.19 368.44 209.728)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.0397,
    cy: 525.79,
    r: 0.570718,
    transform: "rotate(90.19 14.0397 525.79)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.536,
    cy: 435.767,
    r: 0.421643,
    transform: "rotate(90.19 392.536 435.767)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.603,
    cy: 693.475,
    r: 0.411519,
    transform: "rotate(90.19 364.603 693.475)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.715,
    cy: 111.717,
    r: 0.509668,
    transform: "rotate(90.19 202.715 111.717)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.152,
    cy: 93.9035,
    r: 0.628029,
    transform: "rotate(90.19 355.152 93.9035)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.7097,
    cy: 581.485,
    r: 0.59912,
    transform: "rotate(90.19 35.7097 581.485)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.75,
    cy: 359.66,
    r: 0.582106,
    transform: "rotate(90.19 138.75 359.66)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.694,
    cy: 626.089,
    r: 0.750679,
    transform: "rotate(90.19 125.694 626.089)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.154,
    cy: 287.441,
    r: 0.727974,
    transform: "rotate(90.19 177.154 287.441)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.581,
    cy: 13.9311,
    r: 0.648625,
    transform: "rotate(90.19 131.581 13.9311)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.965,
    cy: 37.892,
    r: 0.435239,
    transform: "rotate(90.19 304.965 37.892)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.117,
    cy: 257.833,
    r: 0.735467,
    transform: "rotate(90.19 382.117 257.833)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.9908,
    cy: 392.354,
    r: 0.513764,
    transform: "rotate(90.19 51.9908 392.354)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.9601,
    cy: 559.317,
    r: 0.399151,
    transform: "rotate(90.19 22.9601 559.317)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.889,
    cy: 60.0511,
    r: 0.65357,
    transform: "rotate(90.19 202.889 60.0511)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.547,
    cy: 620.335,
    r: 0.596679,
    transform: "rotate(90.19 228.547 620.335)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.6944,
    cy: 131.631,
    r: 0.793423,
    transform: "rotate(90.19 52.6944 131.631)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.0148,
    cy: 68.5272,
    r: 0.508336,
    transform: "rotate(90.19 83.0148 68.5272)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.478,
    cy: 219.532,
    r: 0.457004,
    transform: "rotate(90.19 357.478 219.532)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.61,
    cy: 548.776,
    r: 0.520092,
    transform: "rotate(90.19 251.61 548.776)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.441,
    cy: 227.894,
    r: 0.720873,
    transform: "rotate(90.19 228.441 227.894)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.515,
    cy: 509.937,
    r: 0.778678,
    transform: "rotate(90.19 373.515 509.937)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.26221,
    cy: 176.98,
    r: 0.40466,
    transform: "rotate(90.19 4.26221 176.98)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.611,
    cy: 1.92309,
    r: 0.439686,
    transform: "rotate(90.19 292.611 1.92309)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.34115,
    cy: 464.923,
    r: 0.589029,
    transform: "rotate(90.19 5.34115 464.923)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.306,
    cy: 403.82,
    r: 0.764323,
    transform: "rotate(90.19 345.306 403.82)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4871,
    cy: 427.094,
    r: 0.703892,
    transform: "rotate(90.19 48.4871 427.094)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2906,
    cy: 630.928,
    r: 0.501719,
    transform: "rotate(90.19 93.2906 630.928)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.775,
    cy: 607.542,
    r: 0.580879,
    transform: "rotate(90.19 367.775 607.542)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.234,
    cy: 26.5558,
    r: 0.684531,
    transform: "rotate(90.19 256.234 26.5558)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.1896,
    cy: 233.247,
    r: 0.5126,
    transform: "rotate(90.19 92.1896 233.247)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.3341,
    cy: 420.565,
    r: 0.517409,
    transform: "rotate(90.19 41.3341 420.565)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.299,
    cy: 306.762,
    r: 0.704869,
    transform: "rotate(90.19 377.299 306.762)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.798,
    cy: 319.938,
    r: 0.502538,
    transform: "rotate(90.19 264.798 319.938)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.692,
    cy: 580.796,
    r: 0.624497,
    transform: "rotate(90.19 278.692 580.796)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.588,
    cy: 455.838,
    r: 0.580281,
    transform: "rotate(90.19 13.588 455.838)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.497,
    cy: 244.985,
    r: 0.435058,
    transform: "rotate(90.19 248.497 244.985)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.143,
    cy: 462.386,
    r: 0.504509,
    transform: "rotate(90.19 315.143 462.386)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.606,
    cy: 474.773,
    r: 0.450233,
    transform: "rotate(90.19 124.606 474.773)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.291,
    cy: 667.53,
    r: 0.684961,
    transform: "rotate(90.19 339.291 667.53)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.95,
    cy: 573.505,
    r: 0.554061,
    transform: "rotate(90.19 214.95 573.505)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.17,
    cy: 656.806,
    r: 0.750169,
    transform: "rotate(90.19 270.17 656.806)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.334,
    cy: 323.996,
    r: 0.587035,
    transform: "rotate(90.19 309.334 323.996)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.895,
    cy: 400.456,
    r: 0.772658,
    transform: "rotate(90.19 134.895 400.456)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.534,
    cy: 422.254,
    r: 0.756746,
    transform: "rotate(90.19 361.534 422.254)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7779,
    cy: 613.217,
    r: 0.629686,
    transform: "rotate(90.19 15.7779 613.217)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.857,
    cy: 111.406,
    r: 0.714863,
    transform: "rotate(90.19 144.857 111.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.391,
    cy: 358.269,
    r: 0.548471,
    transform: "rotate(90.19 121.391 358.269)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.809,
    cy: 475.766,
    r: 0.588258,
    transform: "rotate(90.19 302.809 475.766)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.163,
    cy: 298.495,
    r: 0.425567,
    transform: "rotate(90.19 261.163 298.495)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.478,
    cy: 577.253,
    r: 0.794163,
    transform: "rotate(90.19 286.478 577.253)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.927,
    cy: 429.005,
    r: 0.67792,
    transform: "rotate(90.19 278.927 429.005)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.0076,
    cy: 350.12,
    r: 0.774394,
    transform: "rotate(90.19 86.0076 350.12)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.1548,
    cy: 190.766,
    r: 0.69324,
    transform: "rotate(90.19 94.1548 190.766)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.187,
    cy: 246.479,
    r: 0.4405,
    transform: "rotate(90.19 224.187 246.479)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.226,
    cy: 517.417,
    r: 0.611522,
    transform: "rotate(90.19 272.226 517.417)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.854,
    cy: 95.8219,
    r: 0.702871,
    transform: "rotate(90.19 355.854 95.8219)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.546,
    cy: 354.599,
    r: 0.423888,
    transform: "rotate(90.19 297.546 354.599)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.918,
    cy: 417.11,
    r: 0.470561,
    transform: "rotate(90.19 389.918 417.11)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.6954,
    cy: 634.718,
    r: 0.70864,
    transform: "rotate(90.19 69.6954 634.718)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.2284,
    cy: 517.136,
    r: 0.639813,
    transform: "rotate(90.19 26.2284 517.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.632,
    cy: 645.495,
    r: 0.438976,
    transform: "rotate(90.19 276.632 645.495)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.37,
    cy: 359.051,
    r: 0.687937,
    transform: "rotate(90.19 185.37 359.051)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.361,
    cy: 9.48758,
    r: 0.543335,
    transform: "rotate(90.19 310.361 9.48758)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.552,
    cy: 3.07265,
    r: 0.465552,
    transform: "rotate(90.19 274.552 3.07265)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.372,
    cy: 25.9516,
    r: 0.399725,
    transform: "rotate(90.19 284.372 25.9516)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.21,
    cy: 600.125,
    r: 0.607371,
    transform: "rotate(90.19 379.21 600.125)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.883,
    cy: 636.501,
    r: 0.666347,
    transform: "rotate(90.19 200.883 636.501)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.3568,
    cy: 307.663,
    r: 0.765625,
    transform: "rotate(90.19 69.3568 307.663)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.4735,
    cy: 140.07,
    r: 0.41018,
    transform: "rotate(90.19 98.4735 140.07)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.289,
    cy: 362.267,
    r: 0.785814,
    transform: "rotate(90.19 132.289 362.267)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.443,
    cy: 261.901,
    r: 0.423928,
    transform: "rotate(90.19 105.443 261.901)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.393,
    cy: 97.9723,
    r: 0.555398,
    transform: "rotate(90.19 38.393 97.9723)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.204,
    cy: 207.11,
    r: 0.758335,
    transform: "rotate(90.19 272.204 207.11)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.559,
    cy: 327.38,
    r: 0.413477,
    transform: "rotate(90.19 296.559 327.38)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5082,
    cy: 69.4403,
    r: 0.718339,
    transform: "rotate(90.19 62.5082 69.4403)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.555,
    cy: 271.506,
    r: 0.408137,
    transform: "rotate(90.19 263.555 271.506)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.482,
    cy: 353.574,
    r: 0.51288,
    transform: "rotate(90.19 199.482 353.574)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6056,
    cy: 287.371,
    r: 0.611765,
    transform: "rotate(90.19 11.6056 287.371)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.79,
    cy: 112.406,
    r: 0.487479,
    transform: "rotate(90.19 159.79 112.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.9466,
    cy: 230.53,
    r: 0.54173,
    transform: "rotate(90.19 84.9466 230.53)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5135,
    cy: 600.038,
    r: 0.757054,
    transform: "rotate(90.19 83.5135 600.038)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.171,
    cy: 129.279,
    r: 0.703638,
    transform: "rotate(90.19 390.171 129.279)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.087,
    cy: 603.234,
    r: 0.539387,
    transform: "rotate(90.19 243.087 603.234)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.127,
    cy: 339.887,
    r: 0.699427,
    transform: "rotate(90.19 264.127 339.887)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.4794,
    cy: 354.154,
    r: 0.787086,
    transform: "rotate(90.19 45.4794 354.154)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.349,
    cy: 607.221,
    r: 0.475783,
    transform: "rotate(90.19 134.349 607.221)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8163,
    cy: 95.4548,
    r: 0.591088,
    transform: "rotate(90.19 22.8163 95.4548)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.31,
    cy: 284.376,
    r: 0.404144,
    transform: "rotate(90.19 116.31 284.376)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.981,
    cy: 501.999,
    r: 0.646706,
    transform: "rotate(90.19 110.981 501.999)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.293,
    cy: 215.6,
    r: 0.634278,
    transform: "rotate(90.19 212.293 215.6)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.695,
    cy: 90.9798,
    r: 0.493936,
    transform: "rotate(90.19 140.695 90.9798)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.248,
    cy: 28.9888,
    r: 0.72583,
    transform: "rotate(90.19 276.248 28.9888)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.239,
    cy: 190.198,
    r: 0.669326,
    transform: "rotate(90.19 241.239 190.198)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.8227,
    cy: 703.46,
    r: 0.407983,
    transform: "rotate(90.19 62.8227 703.46)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.186,
    cy: 316.982,
    r: 0.566902,
    transform: "rotate(90.19 370.186 316.982)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.361,
    cy: 330.395,
    r: 0.430831,
    transform: "rotate(90.19 144.361 330.395)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.048,
    cy: 210.983,
    r: 0.429472,
    transform: "rotate(90.19 378.048 210.983)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.756,
    cy: 261.973,
    r: 0.493837,
    transform: "rotate(90.19 112.756 261.973)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.3894,
    cy: 509.869,
    r: 0.623048,
    transform: "rotate(90.19 54.3894 509.869)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.533,
    cy: 581.564,
    r: 0.461646,
    transform: "rotate(90.19 105.533 581.564)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.6313,
    cy: 672.494,
    r: 0.595348,
    transform: "rotate(90.19 86.6313 672.494)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.3566,
    cy: 246.307,
    r: 0.551659,
    transform: "rotate(90.19 68.3566 246.307)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.62,
    cy: 229.772,
    r: 0.654411,
    transform: "rotate(90.19 213.62 229.772)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6982,
    cy: 668.316,
    r: 0.4769,
    transform: "rotate(90.19 15.6982 668.316)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.221,
    cy: 468.797,
    r: 0.687801,
    transform: "rotate(90.19 130.221 468.797)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.784,
    cy: 658.047,
    r: 0.473412,
    transform: "rotate(90.19 321.784 658.047)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.836,
    cy: 683.973,
    r: 0.740835,
    transform: "rotate(90.19 267.836 683.973)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.18347,
    cy: 541.567,
    r: 0.410261,
    transform: "rotate(90.19 5.18347 541.567)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.664,
    cy: 565.154,
    r: 0.560077,
    transform: "rotate(90.19 294.664 565.154)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.014,
    cy: 220.02,
    r: 0.486202,
    transform: "rotate(90.19 230.014 220.02)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.55,
    cy: 286.87,
    r: 0.601832,
    transform: "rotate(90.19 375.55 286.87)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.048,
    cy: 98.1604,
    r: 0.579577,
    transform: "rotate(90.19 187.048 98.1604)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.906,
    cy: 656.736,
    r: 0.724207,
    transform: "rotate(90.19 342.906 656.736)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.914,
    cy: 83.6798,
    r: 0.439091,
    transform: "rotate(90.19 277.914 83.6798)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.031,
    cy: 625.914,
    r: 0.636058,
    transform: "rotate(90.19 170.031 625.914)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.064,
    cy: 590.657,
    r: 0.737532,
    transform: "rotate(90.19 130.064 590.657)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.349,
    cy: 272.127,
    r: 0.501545,
    transform: "rotate(90.19 239.349 272.127)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.656,
    cy: 141.012,
    r: 0.50864,
    transform: "rotate(90.19 161.656 141.012)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.1254,
    cy: 626.128,
    r: 0.641361,
    transform: "rotate(90.19 82.1254 626.128)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4944,
    cy: 534.132,
    r: 0.613518,
    transform: "rotate(90.19 48.4944 534.132)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.359,
    cy: 45.7226,
    r: 0.634635,
    transform: "rotate(90.19 254.359 45.7226)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.325,
    cy: 39.3935,
    r: 0.746034,
    transform: "rotate(90.19 253.325 39.3935)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.595,
    cy: 39.2496,
    r: 0.614632,
    transform: "rotate(90.19 162.595 39.2496)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.394,
    cy: 166.125,
    r: 0.722838,
    transform: "rotate(90.19 341.394 166.125)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.597,
    cy: 699.51,
    r: 0.453911,
    transform: "rotate(90.19 179.597 699.51)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7402,
    cy: 61.7787,
    r: 0.601513,
    transform: "rotate(90.19 87.7402 61.7787)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.1679,
    cy: 341.446,
    r: 0.531769,
    transform: "rotate(90.19 76.1679 341.446)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.7104,
    cy: 174.573,
    r: 0.594996,
    transform: "rotate(90.19 30.7104 174.573)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0935,
    cy: 120.206,
    r: 0.608494,
    transform: "rotate(90.19 28.0935 120.206)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.6426,
    cy: 458.116,
    r: 0.511144,
    transform: "rotate(90.19 78.6426 458.116)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.267,
    cy: 47.3952,
    r: 0.515589,
    transform: "rotate(90.19 263.267 47.3952)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.486,
    cy: 577.801,
    r: 0.773066,
    transform: "rotate(90.19 176.486 577.801)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.19,
    cy: 322.842,
    r: 0.616741,
    transform: "rotate(90.19 147.19 322.842)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.261,
    cy: 243.697,
    r: 0.718276,
    transform: "rotate(90.19 121.261 243.697)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.169,
    cy: 320.471,
    r: 0.75105,
    transform: "rotate(90.19 264.169 320.471)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.406,
    cy: 674.038,
    r: 0.751298,
    transform: "rotate(90.19 307.406 674.038)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.2206,
    cy: 170.461,
    r: 0.620094,
    transform: "rotate(90.19 65.2206 170.461)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.16,
    cy: 477.241,
    r: 0.524528,
    transform: "rotate(90.19 264.16 477.241)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.677,
    cy: 457.5,
    r: 0.515629,
    transform: "rotate(90.19 111.677 457.5)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.166,
    cy: 480.604,
    r: 0.576245,
    transform: "rotate(90.19 213.166 480.604)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.068,
    cy: 312.774,
    r: 0.574834,
    transform: "rotate(90.19 260.068 312.774)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.0652,
    cy: 527.899,
    r: 0.713545,
    transform: "rotate(90.19 35.0652 527.899)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.2229,
    cy: 380.881,
    r: 0.484473,
    transform: "rotate(90.19 23.2229 380.881)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.903,
    cy: 606.784,
    r: 0.747488,
    transform: "rotate(90.19 330.903 606.784)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.8073,
    cy: 579.257,
    r: 0.713783,
    transform: "rotate(90.19 40.8073 579.257)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.616,
    cy: 158.5,
    r: 0.791775,
    transform: "rotate(90.19 159.616 158.5)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.183,
    cy: 19.2498,
    r: 0.565595,
    transform: "rotate(90.19 175.183 19.2498)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.421,
    cy: 635.157,
    r: 0.560264,
    transform: "rotate(90.19 282.421 635.157)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.566,
    cy: 220.918,
    r: 0.441399,
    transform: "rotate(90.19 325.566 220.918)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.426,
    cy: 90.1912,
    r: 0.680962,
    transform: "rotate(90.19 160.426 90.1912)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.115,
    cy: 22.3683,
    r: 0.458475,
    transform: "rotate(90.19 213.115 22.3683)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.7551,
    cy: 238.329,
    r: 0.708661,
    transform: "rotate(90.19 75.7551 238.329)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.822,
    cy: 532.548,
    r: 0.555763,
    transform: "rotate(90.19 314.822 532.548)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.285,
    cy: 478.308,
    r: 0.556381,
    transform: "rotate(90.19 276.285 478.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.966,
    cy: 168.74,
    r: 0.62116,
    transform: "rotate(90.19 164.966 168.74)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.656,
    cy: 385.206,
    r: 0.697687,
    transform: "rotate(90.19 329.656 385.206)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.102,
    cy: 218.038,
    r: 0.6562,
    transform: "rotate(90.19 145.102 218.038)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.877,
    cy: 584.913,
    r: 0.707464,
    transform: "rotate(90.19 388.877 584.913)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.305,
    cy: 345.943,
    r: 0.429562,
    transform: "rotate(90.19 251.305 345.943)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.047,
    cy: 567.797,
    r: 0.755813,
    transform: "rotate(90.19 385.047 567.797)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0758,
    cy: 72.0379,
    r: 0.699426,
    transform: "rotate(90.19 46.0758 72.0379)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.314,
    cy: 625.474,
    r: 0.726301,
    transform: "rotate(90.19 102.314 625.474)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.103,
    cy: 637.165,
    r: 0.56999,
    transform: "rotate(90.19 114.103 637.165)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.794,
    cy: 470.161,
    r: 0.646018,
    transform: "rotate(90.19 248.794 470.161)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.864,
    cy: 108.282,
    r: 0.694221,
    transform: "rotate(90.19 306.864 108.282)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.804,
    cy: 144.235,
    r: 0.505587,
    transform: "rotate(90.19 251.804 144.235)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.659,
    cy: 604.141,
    r: 0.754267,
    transform: "rotate(90.19 349.659 604.141)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.314,
    cy: 582.248,
    r: 0.623578,
    transform: "rotate(90.19 145.314 582.248)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.496,
    cy: 672.869,
    r: 0.74238,
    transform: "rotate(90.19 288.496 672.869)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.9105,
    cy: 396.337,
    r: 0.772616,
    transform: "rotate(90.19 19.9105 396.337)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.195,
    cy: 600.301,
    r: 0.623807,
    transform: "rotate(90.19 222.195 600.301)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.957,
    cy: 279.552,
    r: 0.66917,
    transform: "rotate(90.19 104.957 279.552)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.3208,
    cy: 344.158,
    r: 0.431765,
    transform: "rotate(90.19 50.3208 344.158)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.366,
    cy: 388.03,
    r: 0.655503,
    transform: "rotate(90.19 370.366 388.03)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.179,
    cy: 106.003,
    r: 0.471836,
    transform: "rotate(90.19 239.179 106.003)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2285,
    cy: 266.874,
    r: 0.456839,
    transform: "rotate(90.19 11.2285 266.874)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2244,
    cy: 31.3073,
    r: 0.693422,
    transform: "rotate(90.19 14.2244 31.3073)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.0494,
    cy: 162.334,
    r: 0.416099,
    transform: "rotate(90.19 45.0494 162.334)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.157,
    cy: 22.1353,
    r: 0.495114,
    transform: "rotate(90.19 365.157 22.1353)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.912,
    cy: 196.538,
    r: 0.59148,
    transform: "rotate(90.19 238.912 196.538)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5579,
    cy: 405.7,
    r: 0.647371,
    transform: "rotate(90.19 11.5579 405.7)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5022,
    cy: 413.513,
    r: 0.455497,
    transform: "rotate(90.19 36.5022 413.513)",
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_880_1864)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.808,
    cy: 431.031,
    rx: 252.704,
    ry: 88.7342,
    transform: "rotate(-179.933 209.808 431.031)",
    fill: "#836937",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_880_1864",
    x: -115.861,
    y: 269.332,
    width: 651.338,
    height: 323.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.4824,
    result: "effect1_foregroundBlur_880_1864"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 702.904,
    height: 394.073,
    fill: "white",
    transform: "translate(398.706 0.466553) rotate(90.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_880_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 794.787,
    height: 794.787,
    fill: "white",
    transform: "translate(398.706 0.466553) rotate(90.19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetMobileStarfield);
export default __webpack_public_path__ + "static/media/reset-mobile-starfield.bcff564de0321e4cb2832daec38688ea.svg";
export { ForwardRef as ReactComponent };